/**
 * Decode a JWT payload (no verification; for reading claims only).
 * Used by Heap and Raygun for user identity.
 */

export function parseJwt(token: string): Record<string, unknown> {
  const base64Url = token.includes('.') ? token.split('.')[1] : token;
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((str: string) => '%' + ('00' + str.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
  return JSON.parse(jsonPayload) as Record<string, unknown>;
}
